import axios from './http';

export default {
  getAllReferenceMetas: () => axios.get('api/reference_metas/'),
  getAllForcs: id => axios.get('api/forcs/', { params: { meta_id: id } }),
};
